{
  "title": "Locate Creature",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level divination",
  "level": 4,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a bit of fur from a bloodhound)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "Describe or name a creature that is familiar to you. You sense the direction to the creature’s location, as long as that creature is within 1,000 feet of you. If the creature is moving, you know the direction of its movement.",
    "The spell can locate a specific creature known to you, or the nearest creature of a specific kind (such as a human or a unicorn), so long as you have seen such a creature up close – within 30 feet – at least once. If the creature you described or named is in a different form, such as being under the effects of a polymorph spell, this spell doesn’t locate the creature.",
    "This spell can’t locate a creature if running water at least 10 feet wide blocks a direct path between you and the creature."
  ],
  "spellLists": ["bard", "cleric", "druid", "paladin", "ranger", "wizard"]
}
